// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"602e64de","236":"5670dd12","703":"0f7a0eb7"}[chunkId] + ".chunk.js";
};